<template>
  <base-button
    :class="$style.container"
    @click="handleClick"
  >
    <base-icon
      v-z-index="100"
      name="basic_bar-chart"
    />
    <div
      :class="[
        $style.corners,
        { [$style.visible]: isActive },
      ]"
    ></div>
  </base-button>
</template>

<script>
import BaseButton from 'atoms/base/BaseButton';

export default {
  name: 'GraphButton',
  components: {
    BaseButton,
  },
  data() {
    return {
      isActive: false,
    };
  },
  methods: {
    handleClick() {
      this.isActive = !this.isActive;
      this.$emit('click');
    },
  },
};
</script>

<style lang="sass" module>
  .container
    width: 50px
    height: 50px
    min-width: 50px
    position: relative
    display: flex
    justify-content: center
    align-items: center
    color: #DADADA
    background-color: #181722
    border-radius: 50%

  .corners
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%
    background-color: #1E1D2F
    border-top-left-radius: 20px
    border-top-right-radius: 20px
    transition: all 0.1s linear
    opacity: 0

    &:before
      content: ''
      position: absolute
      bottom: 0px
      left: 0px
      width: 20px
      height: 20px
      border-bottom-right-radius: 10px
      background-color: #27283C
      box-shadow: 0 10px 0 0 #1E1D2F

    &:after
      content: ''
      position: absolute
      bottom: 0px
      right: 0px
      width: 20px
      height: 20px
      border-bottom-left-radius: 10px
      background-color: #27283C
      box-shadow: 0 10px 0 0 #1E1D2F

    &.visible
      height: calc(100% + 20px)
      opacity: 1

      &:before
        left: -20px

      &:after
        right: -20px
</style>
